import pkceChallenge from "pkce-challenge";


class Token {
    constructor(accessToken, refreshToken) {
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
    }
}


export default class OAuth {

    constructor(authUrl, clientId, redirectUrl) {
        this.authUrl = authUrl;
        this.clientId = clientId;
        this.redirectUrl = redirectUrl;
        this.method = "S256";
        this.tokenPropertyName = 'cree.token';
    }

    logout() {
        this.clearToken();
        let f = document.createElement('form');
        f.action = this.authUrl + '/logout?redirect_uri=' + this.redirectUrl;
        f.method = 'POST';
        let i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'fragment';
        i.value = '<!DOCTYPE html>' + document.documentElement.outerHTML;
        f.appendChild(i);
        document.body.appendChild(f);
        f.submit();
    }

    auth() {
        this.clearToken();
        const challenge = pkceChallenge(128);
        let query = {
            client_id: this.clientId,
            redirect_uri: this.redirectUrl,
            response_type: "code",
            code_challenge_method: this.method,
            code_challenge: challenge.code_challenge,
            state: this.randomString(11)
        };
        localStorage.setItem("verifier", challenge.code_verifier);
        location.href = this.authUrl + "/auth?" + new URLSearchParams(query).toString();
    }

    requestToken() {
        let xhr = new XMLHttpRequest();
        xhr.open("POST", this.authUrl + "/token", false);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        const codeVerifier = this.getVerifier(true);

        let data = {
            grant_type: "authorization_code",
            client_id: this.clientId,
            redirect_uri: this.redirectUrl,
            code: this.getQueryParameter('code'),
            code_verifier: codeVerifier,
        };

        xhr.send(new URLSearchParams(data).toString());
        if (xhr.status === 200) {
            const data = JSON.parse(xhr.responseText);
            this.storeToken(new Token(data.access_token, data.refresh_token));
        } else {
            throw new Error('Cant request token');
        }
    }

    refreshToken() {

        const token = this.getToken();

        if (!token)
            throw new Error('Cant refresh token token');

        let xhr = new XMLHttpRequest();
        xhr.open("POST", this.authUrl + "/token", false);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        this.clearVerifier();

        let data = {
            grant_type: "refresh_token",
            client_id: this.clientId,
            redirect_uri: this.redirectUrl,
            refresh_token: token.refreshToken,
        };

        xhr.send(new URLSearchParams(data).toString());

        if (xhr.status === 200) {
            const data = JSON.parse(xhr.responseText);
            this.storeToken(new Token(data.access_token, data.refresh_token));
        } else {
            this.clearToken();
            return this.auth();
        }
    }

    isUMA(response) {
        const authenticate = response.headers.get("www-authenticate");

        if (!authenticate)
            return false;

        if (!authenticate.startsWith("UMA"))
            return false;

        const tokens = authenticate.split(",");

        for (const token of tokens) {
            const [name, value] = token.trim().replaceAll('"', '').split('=');
            if (name === 'resource' && value)
                return true;
        }

        return false;
    }

    requestRPT(response) {
        const token = this.getToken();
        const authenticate = response.headers.get("www-authenticate");
        const tokens = authenticate.split(",");
        let resource = null;

        for (const token of tokens) {
            const [name, value] = token.trim().replaceAll('"', '').split('=');
            if (name === 'resource' && value)
                resource = value;
        }

        this.RPT(token.accessToken, resource);
    }

    RPT(accessToken, resource) {

        let xhr = new XMLHttpRequest();
        xhr.open("POST", this.authUrl + "/token", false);
        xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
        xhr.setRequestHeader("Accept", "application/json");
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        let data = {
            grant_type: 'urn:ietf:params:oauth:grant-type:uma-ticket',
            audience: 'creelayer.marketplace.resource',
            permission: resource,
            // rpt: accessToken
        };

        xhr.send(new URLSearchParams(data).toString());
        if (xhr.status === 200) {
            const data = JSON.parse(xhr.responseText);
            const token = new Token(data.access_token, data.refresh_token);
            this.storeToken(token);
            return token;
        }

        throw new Error("Cant access resource");

    }

    getVerifier(clear) {
        const codeVerifier = localStorage.getItem("verifier");

        if (clear)
            this.clearVerifier();

        return codeVerifier;
    }

    clearVerifier() {
        localStorage.removeItem("verifier");
    }

    storeToken(token) {
        window.localStorage.setItem(this.tokenPropertyName, JSON.stringify(token));
    }

    clearToken() {
        window.localStorage.removeItem(this.tokenPropertyName);
    }

    getToken() {
        const json = window.localStorage.getItem(this.tokenPropertyName);

        if (typeof json == 'undefined' || json === 'undefined' || !json)
            return null;

        const data = JSON.parse(json);

        return new Token(data.accessToken, data.refreshToken);
    }


    randomString(length) {

        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;

    }

    getQueryParameter(name) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        return typeof params[name] !== 'undefined' ? params[name] : null;
    }

}


